const normalizeMaker = (manufacturer) => {
  if (!manufacturer) return "";
  manufacturer = manufacturer.toLowerCase();
  if (
    ["plusline", "rnl", "comstar", "+line", "md-teile", "wai", "twa"].some((manu) =>
      manufacturer.includes(manu)
    )
  ) {
    return "MD-Teile";
  }
  if (["bosch", "seg"].some((manu) => manufacturer.includes(manu))) {
    return "Bosch";
  }
  return manufacturer;
};

export default normalizeMaker;
